import { render, staticRenderFns } from "./_form.blog.page.vue?vue&type=template&id=97584d1a&scoped=true&"
import script from "./_form.blog.page.vue?vue&type=script&lang=js&"
export * from "./_form.blog.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97584d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
